export default __webpack_public_path__ + "static/media/auth-bg.2d6adc14.png";